import { resetAllState } from '@/store/commonActions.ts'
import { createAppSlice } from './createAppSlice'

type SliceState = {
  message?: string
  isOpen: boolean
  ctaCopy?: string
  position?: 'bottom' | 'top'
}

const initialState: SliceState = {
  isOpen: false,
}

export const toastSlice = createAppSlice({
  extraReducers(builder) {
    builder.addCase(resetAllState, () => initialState)
  },
  initialState: initialState satisfies SliceState as SliceState,
  name: 'toast',
  reducers: (create) => ({
    setIsOpen: create.reducer<boolean>((state, action) => ({
      ...state,
      isOpen: action.payload,
    })),
    show: create.reducer<{
      message: string
      ctaCopy?: string
      position?: SliceState['position']
    }>((_, action) => ({
      ctaCopy: action.payload.ctaCopy,
      isOpen: true,
      message: action.payload.message,
      position: action.payload.position,
    })),
  }),
  selectors: {
    ctaCopy: (state) => state.ctaCopy,
    isOpen: (state) => state.isOpen,
    message: (state) => state.message,
    position: (state) => state.position,
  },
})
